"use client";

import { motion } from "framer-motion";
import { Github, Linkedin, Twitter, ArrowUp } from "lucide-react";

export default function Footer() {
    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const socialLinks = [
        { name: "GitHub", url: "https://github.com/HasanWael", icon: <Github className="w-5 h-5" /> },
        { name: "LinkedIn", url: "https://www.linkedin.com/in/hassan-kamel-948198225/", icon: <Linkedin className="w-5 h-5" /> },
    ];

    return (
        <footer id="footer" className="bg-background dark:bg-surface text-foreground py-12 border-t border-border">
            <div className="container mx-auto px-section-x">
                <div className="grid grid-cols-1 md:grid-cols-3 items-center gap-6">

                    {/* Copyright */}
                    <div className="text-center md:text-left md:justify-self-start">
                        <h3 className="text-xl font-bold mb-1" style={{ fontFamily: "var(--font-playfair), Georgia, serif" }}>
                            HSN
                            <span className="text-accent">.</span>
                        </h3>
                        <p className="text-text-secondary text-sm">
                            © {new Date().getFullYear()} Hasan. All rights reserved.
                        </p>
                    </div>

                    {/* Social Links */}
                    <div className="flex items-center justify-center gap-6 md:justify-self-center">
                        {socialLinks.map((link) => (
                            <a
                                key={link.name}
                                href={link.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-text-secondary hover:text-accent active:text-accent transition-colors duration-300 flex items-center gap-2"
                            >
                                {link.icon}
                                <span className="hidden sm:inline font-medium">{link.name}</span>
                            </a>
                        ))}
                    </div>

                    {/* Back to Top */}
                    <motion.button
                        whileHover={{ y: -5 }}
                        whileTap={{ scale: 0.9 }}
                        onClick={scrollToTop}
                        className="w-10 h-10 rounded-full bg-surface-elevated border border-border flex items-center justify-center text-foreground hover:bg-accent hover:border-accent hover:text-white active:bg-accent active:border-accent active:text-white transition-all duration-300 md:justify-self-end mx-auto md:mx-0"
                        aria-label="Back to top"
                    >
                        <ArrowUp className="w-5 h-5" />
                    </motion.button>
                </div>

                {/* Optional: Navigation Links */}
                <div className="mt-12 pt-8 border-t border-border flex flex-wrap justify-center gap-8 text-sm text-text-secondary">
                    <a href="#hero" className="hover:text-foreground active:text-foreground transition-colors">Home</a>
                    <a href="#projects" className="hover:text-foreground active:text-foreground transition-colors">Work</a>
                    <a href="#case-studies" className="hover:text-foreground active:text-foreground transition-colors">Designs</a>
                    <a href="#skills" className="hover:text-foreground active:text-foreground transition-colors">Skills</a>
                    <a href="#contact" className="hover:text-foreground active:text-foreground transition-colors">Contact</a>
                </div>
            </div>
        </footer>
    );
}
